import { Box, Typography, useTheme } from "@mui/material";
import React from "react";
import BoxSearchIcon from "../../../../../../media/images/icons/box-search";
import CustomAutoComple from "./AutoComplete";
import CustomButton from "../../../../../components/CustomButton";
import ArrowLeftCircle from "../../../../../../media/images/icons/arrow-left-circle";
import ArrowLeftSVG from "../../../../../../media/images/icons/arrow-left";
import LocationOutline from "../../../../../../media/images/icons/location-icon";
import SearchIcon from "../../../../../../media/images/icons/search";

const loadingTypes = [
  { label: "نوع1", id: 1 },
  { label: "نوع2", id: 2 },
  { label: "نوع3", id: 3 },
];
export default function SearchBox() {
  const theme = useTheme();

  return (
    <Box
      sx={{
        // border: "1px solid gray",
        padding: "8px",
        borderRadius: "16px",
        backgroundColor: "background.default",
        boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.2)",
        display: "flex",
        flexDirection: "column",
        gap: "8px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <BoxSearchIcon color={theme.palette.textColor.main} />
        <Typography
          sx={{
            color: "textColor.main",
          }}
        >
          باری که می‌خوای رو سریع پیدا کن:
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          width: "100%",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <CustomAutoComple
          icon={
            <LocationOutline size={18} color={theme.palette.textColor.main} />
          }
          placHolder="مقصد"
          options={loadingTypes}
        />
        <CustomAutoComple
          icon={
            <LocationOutline size={18} color={theme.palette.textColor.main} />
          }
          placHolder="مبدا"
          options={loadingTypes}
        />
      </Box>
      <CustomAutoComple
        placHolder="نوع بارگیری را انتخاب کنید"
        options={loadingTypes}
      />
      <CustomButton
        // loading={loading}
        // onClick={formik.handleSubmit}
        flexDirection="row"
        title="جستجو"
        justifyContent="center"
        bgColor="secondary.main"
        width="100%"
        fSize="16px"
        fontWeight={600}
        px="10px"
        py="10px"
        borderRadius="10px"
        icon1={<SearchIcon size={20} />}
      />
    </Box>
  );
}
